var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.user_role !== 'guest')?_c('div',{staticClass:"text-center mt-1"},[_c('vx-tooltip',{staticClass:"inline-flex mr-5 cursor-pointer",attrs:{"text":'Edit',"position":"bottom"}},[_c('feather-icon',{attrs:{"icon":"EditIcon","svgClasses":`h-4 w-4`},on:{"click":function($event){return _vm.editRow()}}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }